import React from 'react'
import PropTypes from 'prop-types'

import { WebinarInfoPanelComponent, If } from '../../../sharedLegacy/components'
import { WaitingRoomCountdownComponent, ThankYouMessageComponent } from '..'
import { useWebinarColors } from '../../../Designs/blocs/useWebinarColors'
import { useLiveDataQuery } from '../../../global/blocs/useLiveData'
import { useIsWebinarOver } from '../../useAudienceLiveState'

import './SimpleWaitingRoomScreenComponent.scss'
import './SimpleWaitingRoomScreenComponent.mobile.scss'

const renderInfoPanel = (isMobileDevice) => (
  <WebinarInfoPanelComponent
    theme="waiting-room"
    speakersSize={isMobileDevice ? 'small' : 'large'}
    style={{ color: '#FFFFFF' }}
  />
)

const SimpleWaitingRoomScreenComponent = ({ isMobileDevice }) => {
  const { data: liveData } = useLiveDataQuery()
  const isWebinarOver = useIsWebinarOver()
  const webinarColors = useWebinarColors()

  return (
    <div className="simple-waiting-room-screen-component">
      <div className="waiting-room-content">
        <If condition={liveData?.before_webinar_countdown_p && !isWebinarOver}>
          <WaitingRoomCountdownComponent />
        </If>
        <If condition={!isWebinarOver || !liveData?.after_webinar_link}>
          <div
            className="decoration-line"
            style={{
              background: `linear-gradient(-90deg, rgb(30, 30, 30) 0%, ${webinarColors.accent.color} 100%)`,
            }}
          />
        </If>
        {isWebinarOver ? (
          <ThankYouMessageComponent />
        ) : (
          renderInfoPanel(isMobileDevice)
        )}
      </div>
    </div>
  )
}

SimpleWaitingRoomScreenComponent.propTypes = {
  isMobileDevice: PropTypes.bool,
}

// eslint-disable-next-line import-x/no-default-export
export default SimpleWaitingRoomScreenComponent
